//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { OverlayIconButton } from '@components/atoms/button/Button';
import { MediaAtomPositionMixins } from '@components/atoms/media/MediaAtomPositionMixins';
import ActionSheet, {
  IActionSheetButton,
} from '@components/molecules/action-sheet/ActionSheet';
import { Props as PopoverProps } from '@components/molecules/popover/Popover';
import { ITrackableComponent, withTracking } from '@utils/withTracking';

interface Props
  extends React.HTMLAttributes<HTMLDivElement>,
    ITrackableComponent {
  actionSheetAppendTarget?: PopoverProps['appendTarget'];
  actionSheetConfig: IActionSheetButton[];
  onToggleActionSheet?: (isOpen: boolean) => void;
}

/**
 * The SecondaryAction atom is an ellipsis button that, when
 * clicked, will show an ActionSheet component constructed using
 * the actionSheetConfig prop.
 */
const SecondaryAction = ({
  actionSheetAppendTarget,
  actionSheetConfig,
  className,
  onToggleActionSheet,
  trackingId,
}: Props) => {
  // This aligns the Popover to cover the kebab icon per design's spec.
  const offset = { skidding: 6, distance: -24 };

  return (
    <SecondaryActionContainer className={className} trackingId={trackingId}>
      <ActionSheet
        actionSheetConfig={actionSheetConfig}
        appendTarget={actionSheetAppendTarget}
        offset={offset}
        onToggleActionSheet={onToggleActionSheet}
      >
        <div>
          <LargeOverlayIconButton iconName='more' />
        </div>
      </ActionSheet>
    </SecondaryActionContainer>
  );
};

const SecondaryActionContainer = withTracking(styled.div`
  ${MediaAtomPositionMixins.TopRight};
`);

const LargeOverlayIconButton = styled(OverlayIconButton)(
  ({ theme }) => `
  && button {
    padding: ${theme.spacings[1]} calc(${theme.spacings[1]} + 2px);
    svg {
      transform: rotate(90deg);
      height: ${theme.spacings[4]};
      width: calc(${theme.spacings[4]} - 4px);
    }
  }
`,
);

export default SecondaryAction;
